//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      xl: {},
      lg: {},
      md: {},
      sm: {},
      xs: {}
    };
  },
  methods: {
    $ready: function $ready() {
      this.xl = this.spec.xl || this.xl;
      this.lg = this.spec.lg || this.lg;
      this.md = this.spec.md || this.md;
      this.sm = this.spec.sm || this.sm;
      this.xs = this.spec.xs || this.xs;
    },
    cssStyles: function cssStyles() {
      var styles = this.$styles();

      switch (this.$vuetify.breakpoint.name) {
        case "xl":
          this.applyStyles(styles, this.xs);
          this.applyStyles(styles, this.sm);
          this.applyStyles(styles, this.md);
          this.applyStyles(styles, this.lg);
          this.applyStyles(styles, this.xl);
          this.applyStyles(styles, this.spec.xlAndDown || {});
          this.applyStyles(styles, this.spec.xlOnly || {});
          break;

        case "lg":
          this.applyStyles(styles, this.xs);
          this.applyStyles(styles, this.sm);
          this.applyStyles(styles, this.md);
          this.applyStyles(styles, this.lg);
          this.applyStyles(styles, this.spec.xlAndDown || {});
          this.applyStyles(styles, this.spec.lgAndDown || {});
          this.applyStyles(styles, this.spec.lgOnly || {});
          break;

        case "md":
          this.applyStyles(styles, this.xs);
          this.applyStyles(styles, this.sm);
          this.applyStyles(styles, this.md);
          this.applyStyles(styles, this.spec.xlAndDown || {});
          this.applyStyles(styles, this.spec.lgAndDown || {});
          this.applyStyles(styles, this.spec.mdAndDown || {});
          this.applyStyles(styles, this.spec.mdOnly || {});
          break;

        case "sm":
          this.applyStyles(styles, this.xs);
          this.applyStyles(styles, this.sm);
          this.applyStyles(styles, this.spec.xlAndDown || {});
          this.applyStyles(styles, this.spec.lgAndDown || {});
          this.applyStyles(styles, this.spec.mdAndDown || {});
          this.applyStyles(styles, this.spec.smAndDown || {});
          this.applyStyles(styles, this.spec.smOnly || {});
          break;

        case "xs":
          this.applyStyles(styles, this.xs);
          this.applyStyles(styles, this.spec.xlAndDown || {});
          this.applyStyles(styles, this.spec.lgAndDown || {});
          this.applyStyles(styles, this.spec.mdAndDown || {});
          this.applyStyles(styles, this.spec.smAndDown || {});
          this.applyStyles(styles, this.spec.xsAndDown || {});
          this.applyStyles(styles, this.spec.xsOnly || {});
          break;
      }

      return styles;
    },
    applyStyles: function applyStyles(styles, spec) {
      Object.assign(styles, this.$styles(spec));
      Utils.type.ifBoolean(spec.hide, function () {
        styles["display"] = "none";
      });
    }
  }
};